export const LAYOUT_ROWS = 2;
export const CONTENT_MIN_WIDTH = "1400px";
export const NAV_MENU_WIDTH = "80px";
export const NAV_MENU_EXPANDED_WIDTH = "250px";
export const LIST_NAVIGATION_WIDTH = "313px";
export const DEFAULT_LAYOUT_CARD_WIDTH = "500px";
export const SIGN_IN_MIN_WIDTH = "1200px";
export const SIGN_IN_MIN_HEIGHT = "700px";
